<template>
  <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
    <b-modal
      v-model="modalAberto"
      :title="titulo"
      size="lg"
      header-bg-variant="secondary"
      header-text-variant="light"
      @hide="closeModal"
      centered
    >
      <b-form @submit.prevent="handleSubmit(prorrogar)">
        <b-container>
          <b-row>
            <b-col cols="6">
              <default-form-validation-provider label="Data de prorrogação">
                <b-form-datepicker
                  id="input-data-ini-vigencia"
                  v-bind="datePickerProps"
                  v-model="novaData"
                  :min="dataMinima"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Data de vencimento atual"
                label-class="text-left"
              >
                <b-form-datepicker
                  disabled
                  v-bind="datePickerProps"
                  v-model="manifestacao.DataVencimentoAtualizada"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="mb-3">
              <span class="d-block text-left pb-1">Justificativa*</span>
              <div id="mensagemWrapper">
                <rich-text-editor
                  @update-value="atualizarValor"
                  :initial-content="justificativa"
                />
              </div>
              <span
                v-if="inputValido === false"
                class="d-block text-danger text-left pt-1 small"
              >
                Campo obrigatório, por favor preencher.
              </span>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="closeModal"
          >Cancelar</b-button
        >
        <b-button
          size="sm"
          variant="secondary"
          type="submit"
          @click="prorrogar"
        >
          Prorrogar Manifestação
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import RichTextEditor from "@/components/RichTextEditor.vue";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { Manifestacao } from "@/types/administracao/ouvidoria/manifestacao";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    RichTextEditor,
  },
})
export default class ModalProrrogarManifestacao extends mixins(UtilsTS, Vue) {
  @Prop({ required: true }) manifestacao!: Manifestacao;
  @Prop({ required: true }) titulo!: string;

  datePickerProps = DatePickerDefaultProps;
  modalAberto = true;
  justificativa = "";
  inputValido = false;

  novaData = new Date();
  dataMinima = new Date();

  atualizarValor(value: string) {
    this.inputValido = value !== "";
    this.justificativa = value;
  }

  async prorrogar() {
    try {
      if (!this.novaData) return this.$toast.error("Adicione uma nova data!");
      if (!this.inputValido)
        return this.$toast.error("Adicione justificativa!");
      const response = await ouvidoriaService.prorrogarManifestacao(
        this.manifestacao.IdManifestacao,
        this.justificativa,
        this.formatDataDB(this.novaData)
      );
      if (response.status === 200)
        this.$toast.success("Manifestação prorrogada com sucesso!");
      this.reload();
      this.closeModal();
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  closeModal() {
    this.$emit("close");
  }

  reload() {
    this.$emit("reload");
  }

  async created() {
    if (this.manifestacao?.DataVencimentoAtualizada) {
      this.novaData = new Date(this.manifestacao.DataVencimentoAtualizada);
      this.novaData.setDate(this.novaData.getDate() + 1);
      this.dataMinima = new Date(this.novaData);
    }
  }
}
</script>
